import React from "react";
import { useTranslation } from "react-i18next";
import { featuresMenu } from "./menuConfig";

const FONT_STACK =
  "Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif";

const MegaMenu = ({ isOpen }) => {
  const { t } = useTranslation("marketing");

  return (
    <div
      aria-hidden={!isOpen}
      className={`fixed top-[90px] left-1/2 -translate-x-1/2 w-[1160px] max-w-[95vw] z-[9999]
        transition-all duration-200 ease-out ${
          isOpen ? "pointer-events-auto opacity-100 translate-y-0" : "pointer-events-none opacity-0 translate-y-2"
        }`}
      style={{ fontFamily: FONT_STACK }}
    >
      <div
        className="max-h-[420px] overflow-hidden rounded-[28px] border border-slate-200
          bg-white shadow-[0_20px_60px_rgba(15,23,42,0.18)]"
      >
        <div className="px-6 py-6 lg:px-8 lg:py-7">
          <div className="grid gap-8 md:grid-cols-2 xl:grid-cols-4">
            {featuresMenu.map((section, si) => (
              <div
                key={si}
                className={`min-w-0 ${si > 0 ? "xl:border-l xl:border-slate-200 xl:pl-6" : ""}`}
              >
                <p className="mb-4 whitespace-nowrap text-xs font-semibold uppercase tracking-[0.05em] text-[rgb(125,102,51)]">
                  {t(section.titleKey)}
                </p>
                <ul className="space-y-2">
                  {section.items.map((item, ii) => (
                    <li
                      key={ii}
                      className="group cursor-pointer rounded-xl py-1.5 transition-all duration-150 hover:-translate-y-0.5"
                    >
                      <p className="text-[15px] font-medium leading-6 text-slate-900 transition-colors group-hover:text-[rgb(125,102,51)]">
                        {t(item.labelKey)}
                      </p>
                    </li>
                  ))}
                </ul>
              </div>
            ))}

            <div className="min-w-0 xl:border-l xl:border-slate-200 xl:pl-6">
              <div className="flex h-full min-h-[220px] flex-col justify-between rounded-2xl border border-[rgb(125,102,51)]/20 bg-[rgb(248,245,238)] p-5">
                <div>
                  <p className="text-[11px] font-medium uppercase tracking-wide text-[rgb(125,102,51)]">
                    {t("features.cta_eyebrow")}
                  </p>
                  <p className="mt-3 text-[24px] leading-8 font-semibold text-slate-900">
                    {t("features.cta_title")}
                  </p>
                  <p className="mt-3 text-[14px] leading-6 text-slate-600">
                    {t("features.cta_desc")}
                  </p>
                </div>
                <button
                  className="mt-6 inline-flex items-center justify-center rounded-full
                    bg-[#c9a038] px-5 py-3 text-[15px] font-semibold text-[#141414]
                    hover:brightness-110 transition"
                >
                  {t("features.cta_button")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MegaMenu;
